// @ts-nocheck
/* eslint-disable */
export const borderColorIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M80 0v-121h800V0H80Zm140-301h44l391-391-22-22-22-22-391 391v44Zm-60 60v-128l494-494q9-9 20-13t22-4q11 0 22.5 4t19.5 13l44 44q9 8 13.5 19.5T800-777q0 11-4.5 22T782-735L288-241H160Zm576-537-41-41 41 41Zm-81 86-22-22-22-22 44 44Z"/></svg>`,
    name: 'border-color' as const
};